import { createFileRoute } from '@tanstack/react-router'
import { useUsers } from '@/api/hooks/useUsers'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import UserSettings from '@/components/organisms/user-settings'
import { useSetSidebarSubLabel } from '@/contexts/sidebar-sub-label-context'

export const Route = createFileRoute('/_authenticated/users/$userId')({
  component: UserSettingsRoute,
})

function UserSettingsRoute() {
  const { userId } = Route.useParams()
  const { data: users = [], isError, isLoading } = useUsers()
  const user = users.find(u => u.id === userId)

  useSetSidebarSubLabel(`/users/${userId}`, user?.email)

  return (
    <StateSwitcher isError={isError} isLoading={isLoading}>
      {user ? <UserSettings key={user.id} user={user} /> : null}
    </StateSwitcher>
  )
}
